module.exports = __webpack_public_path__ + "img/center-scene.1dc18c23.svg";